/* ============================================
   MELTY WAX — Custom Bundle Builder JS v2
   Premium UI with sidebar, hero, skeleton loaders
   3-step flow:
     Step 1: Choose 1 warmer (auto-advance)
     Step 2: Choose 3 paid melts (manual next)
     Step 3: Choose 2 free melts (manual checkout)
   ============================================ */

(function () {
  'use strict';

  /* ---------- Configuration ---------- */
  const CONFIG = {
    warmerCollection: 'wax-warmers',
    meltsCollection: 'wax-melts',
    paidMeltsCount: 3,
    freeMeltsCount: 2,
    excludeHandles: ['mystery-scent-bundle'],
    bundlePropertyKey: '_Bundle',
    bundlePropertyValue: 'Scent Lab Bundle',
    currency: '$',
    autoAdvanceDelay: 600,
    freeMeltVariantId: 45131952324803,
  };

  /* ---------- SVG Icons ---------- */
  const ICONS = {
    warmer: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M8 21h8m-4-4v4m-4.5-8c-1.5-1.5-2.5-3.5-2.5-5.5A7 7 0 0 1 12 1a7 7 0 0 1 7 6.5c0 2-1 4-2.5 5.5H9.5z"/><path d="M10 8c0 1.1.9 2 2 2s2-.9 2-2"/></svg>',
    melts: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2z"/><path d="M8 12a4 4 0 0 0 8 0"/><circle cx="9" cy="9" r="1" fill="currentColor"/><circle cx="15" cy="9" r="1" fill="currentColor"/></svg>',
    gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13"/><path d="M3 12v7a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M7.5 8a2.5 2.5 0 0 1 0-5C9 3 12 8 12 8"/><path d="M16.5 8a2.5 2.5 0 0 0 0-5C15 3 12 8 12 8"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13" rx="1"/><path d="M16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>',
    heart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>',
  };

  /* ---------- State ---------- */
  const state = {
    currentStep: 1,
    warmer: null,
    melts: [],
    freeMelts: [],
    warmersData: [],
    meltsData: [],
    loading: true,
  };

  /* ---------- DOM ---------- */
  let container;

  /* ---------- Init ---------- */
  function init() {
    container = document.getElementById('mw-bundle-app');
    if (!container) return;
    container.classList.add('mw-bb');
    render();
    fetchProducts();
  }

  /* ---------- Fetch Products ---------- */
  async function fetchProducts() {
    try {
      const [warmersRes, meltsRes] = await Promise.all([
        fetch('/collections/' + CONFIG.warmerCollection + '/products.json?limit=50'),
        fetch('/collections/' + CONFIG.meltsCollection + '/products.json?limit=50'),
      ]);

      const warmersJson = await warmersRes.json();
      const meltsJson = await meltsRes.json();

      state.warmersData = (warmersJson.products || [])
        .filter(function (p) { return p.variants && p.variants.length > 0 && p.variants[0].available; })
        .map(normalizeProduct);

      state.meltsData = (meltsJson.products || [])
        .filter(function (p) {
          return p.variants && p.variants.length > 0 &&
            p.variants[0].available &&
            !CONFIG.excludeHandles.includes(p.handle);
        })
        .map(normalizeProduct);

      state.loading = false;
      render();
    } catch (err) {
      console.error('[MeltyBundle] Failed to fetch products:', err);
      state.loading = false;
      container.innerHTML = '<div style="text-align:center;padding:60px 20px;color:#c0392b;"><p>Something went wrong loading the bundle builder. Please refresh the page.</p></div>';
    }
  }

  function normalizeProduct(p) {
    var v = p.variants[0];
    return {
      id: p.id,
      variantId: v.id,
      title: p.title,
      handle: p.handle,
      price: parseFloat(v.price),
      image: p.images && p.images[0] ? p.images[0].src : '',
      available: v.available,
    };
  }

  /* ---------- Selection Logic ---------- */
  function getTotalQty(arr) {
    return arr.reduce(function (sum, m) { return sum + (m.qty || 1); }, 0);
  }

  function selectWarmer(product) {
    state.warmer = { ...product, qty: 1 };
    render();
    setTimeout(function () { goToStep(2); }, CONFIG.autoAdvanceDelay);
  }

  function toggleMelt(product, listKey) {
    var arr = listKey === 'melts' ? state.melts : state.freeMelts;
    var max = listKey === 'melts' ? CONFIG.paidMeltsCount : CONFIG.freeMeltsCount;
    var existing = arr.find(function (m) { return m.variantId === product.variantId; });
    var total = getTotalQty(arr);

    if (existing) {
      arr.splice(arr.indexOf(existing), 1);
    } else if (total < max) {
      arr.push({ ...product, qty: 1 });
    }

    render();

    // Auto-advance from step 2 to step 3 when all paid melts selected
    if (listKey === 'melts' && getTotalQty(state.melts) === CONFIG.paidMeltsCount) {
      setTimeout(function () { goToStep(3); }, CONFIG.autoAdvanceDelay);
    }

    // Scroll to checkout when all free melts selected
    if (listKey === 'freeMelts' && getTotalQty(state.freeMelts) === CONFIG.freeMeltsCount) {
      scrollToCheckout();
    }
  }

  function adjustMeltQty(product, listKey, delta) {
    var arr = listKey === 'melts' ? state.melts : state.freeMelts;
    var max = listKey === 'melts' ? CONFIG.paidMeltsCount : CONFIG.freeMeltsCount;
    var existing = arr.find(function (m) { return m.variantId === product.variantId; });
    if (!existing) return;

    var total = getTotalQty(arr);
    var newQty = existing.qty + delta;

    if (newQty <= 0) {
      arr.splice(arr.indexOf(existing), 1);
    } else if (delta > 0 && total >= max) {
      return;
    } else {
      existing.qty = newQty;
    }

    render();

    // Auto-advance from step 2 to step 3 when all paid melts selected
    if (listKey === 'melts' && getTotalQty(state.melts) === CONFIG.paidMeltsCount) {
      setTimeout(function () { goToStep(3); }, CONFIG.autoAdvanceDelay);
    }

    // Scroll to checkout when all free melts selected
    if (listKey === 'freeMelts' && getTotalQty(state.freeMelts) === CONFIG.freeMeltsCount) {
      scrollToCheckout();
    }
  }

  /* ---------- Navigation ---------- */
  function goToStep(step) {
    if (step < 1 || step > 3) return;
    if (step > state.currentStep && !isStepValid(state.currentStep)) return;
    state.currentStep = step;
    render();
    window.scrollTo({ top: container.offsetTop - 80, behavior: 'smooth' });
  }

  function scrollToCheckout() {
    setTimeout(function () {
      var checkoutEl = container.querySelector('.mw-bb-checkout');
      if (checkoutEl) checkoutEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 150);
  }

  function isStepValid(step) {
    switch (step) {
      case 1: return state.warmer !== null;
      case 2: return getTotalQty(state.melts) === CONFIG.paidMeltsCount;
      case 3: return getTotalQty(state.freeMelts) === CONFIG.freeMeltsCount;
      default: return false;
    }
  }

  /* ---------- Price Helpers ---------- */
  function getSubtotal() {
    var total = 0;
    if (state.warmer) total += state.warmer.price;
    state.melts.forEach(function (m) { total += m.price * m.qty; });
    return total;
  }

  function getSavings() {
    var savings = 0;
    state.freeMelts.forEach(function (m) { savings += m.price * m.qty; });
    return savings;
  }

  function formatPrice(amount) {
    return CONFIG.currency + amount.toFixed(2);
  }

  /* ---------- Add to Cart & Checkout ---------- */
  function addToCartAndCheckout() {
    var btn = container.querySelector('.mw-bb-btn--checkout');
    if (btn) {
      btn.classList.add('is-loading');
      btn.disabled = true;
    }

    var bundleId = Date.now().toString(36);
    var items = [];

    if (state.warmer) {
      items.push({
        id: state.warmer.variantId,
        quantity: 1,
        properties: {
          [CONFIG.bundlePropertyKey]: CONFIG.bundlePropertyValue,
          '_bundle_id': bundleId,
          '_bundle_step': 'Wax Warmer',
        },
      });
    }

    state.melts.forEach(function (m) {
      items.push({
        id: m.variantId,
        quantity: m.qty,
        properties: {
          [CONFIG.bundlePropertyKey]: CONFIG.bundlePropertyValue,
          '_bundle_id': bundleId,
          '_bundle_step': 'Wax Melts',
        },
      });
    });

    state.freeMelts.forEach(function (m) {
      items.push({
        id: CONFIG.freeMeltVariantId,
        quantity: m.qty,
        properties: {
          'Scent': m.title,
          [CONFIG.bundlePropertyKey]: CONFIG.bundlePropertyValue,
          '_bundle_id': bundleId,
          '_bundle_step': 'Free Bonus Melts',
          '_bundle_free': 'true',
        },
      });
    });

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
    form.style.display = 'none';

    items.forEach(function (item, idx) {
      addHidden(form, 'items[' + idx + '][id]', item.id);
      addHidden(form, 'items[' + idx + '][quantity]', item.quantity);
      Object.keys(item.properties).forEach(function (key) {
        addHidden(form, 'items[' + idx + '][properties][' + key + ']', item.properties[key]);
      });
    });

    addHidden(form, 'return_to', '/checkout');
    document.body.appendChild(form);
    form.submit();
  }

  function addHidden(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function showToast(message) {
    var toast = document.querySelector('.mw-bb-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'mw-bb-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
      setTimeout(function () { toast.classList.remove('is-visible'); }, 3000);
    });
  }

  /* ===========================================
     RENDER
     =========================================== */
  function render() {
    if (!container) return;
    container.innerHTML = '';

    // Hero banner
    container.appendChild(renderHero());

    // Progress bar
    container.appendChild(renderProgress());

    if (state.loading) {
      var layout = ce('div', 'mw-bb-layout');
      var main = ce('div', 'mw-bb-main');
      main.appendChild(renderSkeleton());
      layout.appendChild(main);
      layout.appendChild(renderSidebar());
      container.appendChild(layout);
      return;
    }

    // Main layout: step content + sidebar
    var layout = ce('div', 'mw-bb-layout');
    var main = ce('div', 'mw-bb-main');

    switch (state.currentStep) {
      case 1: main.appendChild(renderStep1()); break;
      case 2: main.appendChild(renderStep2()); break;
      case 3: main.appendChild(renderStep3()); break;
    }

    layout.appendChild(main);
    layout.appendChild(renderSidebar());
    container.appendChild(layout);
  }

  /* ---------- Hero Banner ---------- */
  function renderHero() {
    var hero = ce('div', 'mw-bb-hero');

    var eyebrow = ce('div', 'mw-bb-hero__eyebrow');
    eyebrow.textContent = '\u2728 Bundle & Save';
    hero.appendChild(eyebrow);

    var title = ce('h1', 'mw-bb-hero__title');
    title.textContent = 'Create Your Dream Bundle';
    hero.appendChild(title);

    var subtitle = ce('p', 'mw-bb-hero__subtitle');
    subtitle.textContent = 'Pick your warmer, load up on your fave scents, and we\u2019ll throw in 2 FREE melts because you deserve it \ud83d\udc9c';
    hero.appendChild(subtitle);

    // Savings badge
    var savings = ce('div', 'mw-bb-hero__savings');
    savings.innerHTML = ICONS.tag + ' Save $27.90 on your bundle \ud83c\udf89';
    hero.appendChild(savings);

    return hero;
  }

  /* ---------- Progress Bar ---------- */
  function renderProgress() {
    var progress = ce('div', 'mw-bb-progress');
    var inner = ce('div', 'mw-bb-progress__inner');

    // Fill track
    var track = ce('div', 'mw-bb-progress__track');
    var fill = ce('div', 'mw-bb-progress__fill');
    var fillPercent = ((state.currentStep - 1) / 2) * 100;
    fill.style.width = fillPercent + '%';
    track.appendChild(fill);
    inner.appendChild(track);

    // Step indicators
    var stepsRow = ce('div', 'mw-bb-progress__steps');
    var steps = [
      { num: 1, label: 'Pick Your Warmer \ud83d\udd0c', icon: ICONS.warmer },
      { num: 2, label: 'Pick 3 Melts \ud83d\udc9c', icon: ICONS.melts },
      { num: 3, label: '2 FREE Melts \ud83c\udf81', icon: ICONS.gift },
    ];

    steps.forEach(function (s) {
      var isActive = s.num === state.currentStep;
      var isComplete = s.num < state.currentStep;
      var isClickable = s.num < state.currentStep;

      var stepEl = ce('button', 'mw-bb-progress__step');
      if (isActive) stepEl.classList.add('mw-bb-progress__step--active');
      if (isComplete) stepEl.classList.add('mw-bb-progress__step--complete');
      if (isClickable) stepEl.classList.add('mw-bb-progress__step--clickable');
      stepEl.disabled = !isClickable && !isActive;
      stepEl.setAttribute('aria-current', isActive ? 'step' : 'false');

      stepEl.onclick = function () { if (isClickable) goToStep(s.num); };

      var numEl = ce('span', 'mw-bb-progress__step-num');
      if (isComplete) {
        numEl.innerHTML = ICONS.check;
      } else {
        numEl.textContent = s.num;
      }
      stepEl.appendChild(numEl);

      var labelEl = ce('span', 'mw-bb-progress__step-label');
      labelEl.textContent = s.label;
      stepEl.appendChild(labelEl);

      stepsRow.appendChild(stepEl);
    });

    inner.appendChild(stepsRow);
    progress.appendChild(inner);
    return progress;
  }

  /* ---------- Step 1: Choose Warmer ---------- */
  function renderStep1() {
    var step = ce('div', 'mw-bb-step is-active');

    var header = ce('div', 'mw-bb-step__header');
    var title = ce('h2', 'mw-bb-step__title');
    title.textContent = 'First Up \u2014 Your Warmer \ud83d\udd25';
    var sub = ce('p', 'mw-bb-step__subtitle');
    sub.textContent = 'Tap your warmer and we\u2019ll whisk you to the fun part \u2014 choosing scents!';
    header.appendChild(title);
    header.appendChild(sub);
    step.appendChild(header);

    var grid = ce('div', 'mw-bb-grid mw-bb-grid--warmer');

    state.warmersData.forEach(function (product) {
      var isSelected = state.warmer && state.warmer.variantId === product.variantId;

      var card = ce('div', 'mw-bb-card mw-bb-card--warmer');
      if (isSelected) card.classList.add('is-selected');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      card.setAttribute('aria-label', product.title + ' - ' + formatPrice(product.price));

      card.onclick = function () { selectWarmer(product); };
      card.onkeydown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectWarmer(product); }
      };

      // Badge
      var badge = ce('span', 'mw-bb-card__badge');
      badge.textContent = state.warmersData.length === 1 ? '\u2728 Our Fave' : '\u2728 Featured';
      card.appendChild(badge);

      // Checkmark
      var check = ce('span', 'mw-bb-card__check');
      check.innerHTML = ICONS.check;
      card.appendChild(check);

      // Image
      var imgWrap = ce('div', 'mw-bb-card__img-wrap');
      if (product.image) {
        var img = ce('img');
        img.src = resizeImage(product.image, 500);
        img.alt = product.title;
        img.loading = 'lazy';
        imgWrap.appendChild(img);
      }
      card.appendChild(imgWrap);

      // Name
      var name = ce('p', 'mw-bb-card__name');
      name.textContent = product.title;
      card.appendChild(name);

      // Price
      var price = ce('p', 'mw-bb-card__price');
      price.textContent = formatPrice(product.price);
      card.appendChild(price);

      grid.appendChild(card);
    });

    step.appendChild(grid);
    return step;
  }

  /* ---------- Step 2: Choose 3 Paid Melts ---------- */
  function renderStep2() {
    var step = ce('div', 'mw-bb-step is-active');
    var total = getTotalQty(state.melts);
    var atMax = total >= CONFIG.paidMeltsCount;

    var header = ce('div', 'mw-bb-step__header');
    var title = ce('h2', 'mw-bb-step__title');
    title.textContent = 'Now the Fun Part \u2014 Pick Your Scents! \ud83d\udc9c';
    var sub = ce('p', 'mw-bb-step__subtitle');
    sub.textContent = 'Go on, grab ' + CONFIG.paidMeltsCount + ' packs of pure melty goodness for your bundle';
    header.appendChild(title);
    header.appendChild(sub);

    var counter = ce('div', 'mw-bb-step__counter');
    counter.textContent = total + ' of ' + CONFIG.paidMeltsCount + ' selected';
    if (atMax) counter.classList.add('is-complete');
    header.appendChild(counter);
    step.appendChild(header);

    var grid = ce('div', 'mw-bb-grid');
    state.meltsData.forEach(function (product) {
      grid.appendChild(renderMeltCard(product, 'melts', state.melts, CONFIG.paidMeltsCount));
    });
    step.appendChild(grid);

    // Nav
    var nav = ce('div', 'mw-bb-nav');
    var back = ce('button', 'mw-bb-btn mw-bb-btn--secondary');
    back.type = 'button';
    back.innerHTML = '&larr; Back';
    back.onclick = function () { goToStep(1); };
    nav.appendChild(back);

    var next = ce('button', 'mw-bb-btn mw-bb-btn--primary');
    next.type = 'button';
    next.textContent = 'Gimme My Freebies \u2192';
    next.disabled = !atMax;
    next.onclick = function () { goToStep(3); };
    nav.appendChild(next);
    step.appendChild(nav);

    // Mobile bar
    step.appendChild(renderMobileBar(total, CONFIG.paidMeltsCount, 'Next \u2192', !atMax, function () { goToStep(3); }));

    return step;
  }

  /* ---------- Step 3: Choose 2 Free Melts ---------- */
  function renderStep3() {
    var step = ce('div', 'mw-bb-step is-active mw-bb-step--free');
    var total = getTotalQty(state.freeMelts);
    var atMax = total >= CONFIG.freeMeltsCount;

    var header = ce('div', 'mw-bb-step__header');
    var title = ce('h2', 'mw-bb-step__title');
    title.textContent = 'Treat Yourself \u2014 2 FREE Melts! \ud83c\udf81';
    var sub = ce('p', 'mw-bb-step__subtitle');
    sub.textContent = 'You\u2019ve earned it! Pick 2 bonus scents on the house \ud83e\udd29';
    header.appendChild(title);
    header.appendChild(sub);

    var counter = ce('div', 'mw-bb-step__counter');
    counter.textContent = total + ' of ' + CONFIG.freeMeltsCount + ' selected';
    if (atMax) counter.classList.add('is-complete');
    header.appendChild(counter);
    step.appendChild(header);

    var grid = ce('div', 'mw-bb-grid');
    state.meltsData.forEach(function (product) {
      grid.appendChild(renderMeltCard(product, 'freeMelts', state.freeMelts, CONFIG.freeMeltsCount));
    });
    step.appendChild(grid);

    // Savings callout
    if (atMax) {
      var savings = getSavings();
      if (savings > 0) {
        var callout = ce('div', 'mw-bb-savings');
        callout.innerHTML = '<span class="mw-bb-savings__text">\ud83c\udf89 Yay! You\'re saving <strong>' + formatPrice(savings) + '</strong> with this bundle!</span>';
        step.appendChild(callout);
      }
    }

    // Checkout section (only when all free melts selected)
    if (atMax) {
      step.appendChild(renderCheckout());
    }

    // Nav
    var nav = ce('div', 'mw-bb-nav');
    var back = ce('button', 'mw-bb-btn mw-bb-btn--secondary');
    back.type = 'button';
    back.innerHTML = '&larr; Back';
    back.onclick = function () { goToStep(2); };
    nav.appendChild(back);

    if (!atMax) {
      var checkoutBtn = ce('button', 'mw-bb-btn mw-bb-btn--checkout');
      checkoutBtn.type = 'button';
      checkoutBtn.disabled = true;
      var btnText = ce('span', 'mw-bb-btn__text');
      btnText.textContent = 'Pick ' + (CONFIG.freeMeltsCount - total) + ' more freebie' + ((CONFIG.freeMeltsCount - total) > 1 ? 's' : '') + '!';
      checkoutBtn.appendChild(btnText);
      nav.appendChild(checkoutBtn);
    }

    step.appendChild(nav);

    // Mobile bar
    step.appendChild(renderMobileBar(
      total, CONFIG.freeMeltsCount,
      atMax ? 'Checkout \u2014 ' + formatPrice(getSubtotal()) : 'Pick ' + (CONFIG.freeMeltsCount - total) + ' more!',
      !atMax,
      atMax ? addToCartAndCheckout : function () {}
    ));

    return step;
  }

  /* ---------- Melt Card ---------- */
  function renderMeltCard(product, listKey, selectedArr, maxCount) {
    var existing = selectedArr.find(function (m) { return m.variantId === product.variantId; });
    var isSelected = !!existing;
    var total = getTotalQty(selectedArr);
    var atMax = total >= maxCount;
    var isFree = listKey === 'freeMelts';

    var card = ce('div', 'mw-bb-card');
    if (isSelected) card.classList.add('is-selected');
    if (atMax && !isSelected) card.classList.add('is-blocked');

    card.setAttribute('role', 'button');
    card.setAttribute('tabindex', '0');
    card.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    card.setAttribute('aria-label', product.title + ' - ' + formatPrice(product.price));

    card.onclick = function (e) {
      if (e.target.closest('.mw-bb-card__qty')) return;
      toggleMelt(product, listKey);
    };
    card.onkeydown = function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleMelt(product, listKey); }
    };

    // Image wrapper
    var imgWrap = ce('div', 'mw-bb-card__img-wrap');

    // Animated checkmark
    var check = ce('span', 'mw-bb-card__check');
    if (existing && existing.qty > 1) {
      var checkText = ce('span', 'mw-bb-card__check-text');
      checkText.textContent = existing.qty;
      check.appendChild(checkText);
    } else {
      check.innerHTML = ICONS.check;
    }
    imgWrap.appendChild(check);

    // Product image
    if (product.image) {
      var img = ce('img');
      img.src = resizeImage(product.image, 400);
      img.alt = product.title;
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    card.appendChild(imgWrap);

    // FREE ribbon (step 3) — on card, not imgWrap, to avoid overflow clipping
    if (isFree) {
      var ribbon = ce('span', 'mw-bb-card__ribbon');
      ribbon.textContent = 'FREE';
      card.appendChild(ribbon);
    }

    // Name
    var name = ce('p', 'mw-bb-card__name');
    name.textContent = product.title;
    card.appendChild(name);

    // Price
    var priceEl = ce('p', 'mw-bb-card__price');
    if (isFree) {
      priceEl.innerHTML = '<s>' + formatPrice(product.price) + '</s> <span class="mw-bb-card__price-free">FREE</span>';
    } else {
      priceEl.textContent = formatPrice(product.price);
    }
    card.appendChild(priceEl);

    // Quantity controls
    if (isSelected) {
      var qtyWrap = ce('div', 'mw-bb-card__qty');

      var minus = ce('button', 'mw-bb-card__qty-btn');
      minus.type = 'button';
      minus.textContent = '\u2212';
      minus.setAttribute('aria-label', 'Decrease ' + product.title);
      minus.onclick = function (e) { e.stopPropagation(); adjustMeltQty(product, listKey, -1); };

      var val = ce('span', 'mw-bb-card__qty-val');
      val.textContent = existing.qty;

      var plus = ce('button', 'mw-bb-card__qty-btn');
      plus.type = 'button';
      plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase ' + product.title);
      plus.onclick = function (e) { e.stopPropagation(); adjustMeltQty(product, listKey, 1); };
      if (atMax) plus.disabled = true;

      qtyWrap.appendChild(minus);
      qtyWrap.appendChild(val);
      qtyWrap.appendChild(plus);
      card.appendChild(qtyWrap);
    }

    return card;
  }

  /* ---------- Checkout Section ---------- */
  function renderCheckout() {
    var section = ce('div', 'mw-bb-checkout');

    var title = ce('h3', 'mw-bb-checkout__title');
    title.textContent = 'Looking Good! Your Bundle is Ready \ud83d\ude0d';
    section.appendChild(title);

    // Item grid (3 cols desktop, 2 cols mobile)
    var items = ce('div', 'mw-bb-checkout__items');

    // Warmer
    if (state.warmer) {
      items.appendChild(renderCheckoutItem(state.warmer, false));
    }

    // Paid melts
    state.melts.forEach(function (m) {
      items.appendChild(renderCheckoutItem(m, false));
    });

    // Free melts
    state.freeMelts.forEach(function (m) {
      items.appendChild(renderCheckoutItem(m, true));
    });

    section.appendChild(items);

    // CTA
    var ctaWrap = ce('div', 'mw-bb-checkout__cta');
    var checkoutBtn = ce('button', 'mw-bb-btn mw-bb-btn--checkout');
    checkoutBtn.type = 'button';
    checkoutBtn.style.width = '100%';
    checkoutBtn.style.justifyContent = 'center';

    var btnText = ce('span', 'mw-bb-btn__text');
    btnText.textContent = 'Checkout \u2014 ' + formatPrice(getSubtotal());
    var spinner = ce('span', 'mw-bb-btn__spinner');

    checkoutBtn.appendChild(btnText);
    checkoutBtn.appendChild(spinner);
    checkoutBtn.onclick = addToCartAndCheckout;
    ctaWrap.appendChild(checkoutBtn);
    section.appendChild(ctaWrap);

    // Trust badges
    section.appendChild(renderTrustBadges());

    return section;
  }

  function renderCheckoutItem(product, isFree) {
    var item = ce('div', 'mw-bb-checkout__item');

    var imgWrap = ce('div', 'mw-bb-checkout__item-img');
    if (product.image) {
      var img = ce('img');
      img.src = resizeImage(product.image, 100);
      img.alt = product.title;
      imgWrap.appendChild(img);
    }
    item.appendChild(imgWrap);

    var label = ce('span', 'mw-bb-checkout__item-label');
    if (isFree) label.classList.add('mw-bb-checkout__item-label--free');
    // Shorten title for display
    var shortTitle = product.title
      .replace(' Wax Melts', '')
      .replace(' Wax Melt', '')
      .replace('Melty Wax ', '');
    label.textContent = isFree ? '\ud83c\udf81 ' + shortTitle : shortTitle;
    item.appendChild(label);

    return item;
  }

  /* ---------- Trust Badges ---------- */
  function renderTrustBadges() {
    var wrap = ce('div', 'mw-bb-trust');
    var badges = [
      { icon: ICONS.truck, label: 'Free Shipping' },
      { icon: ICONS.shield, label: 'Secure Checkout' },
      { icon: ICONS.heart, label: '100% Satisfaction' },
    ];

    badges.forEach(function (b) {
      var badge = ce('div', 'mw-bb-trust__badge');
      badge.innerHTML = b.icon + '<span>' + b.label + '</span>';
      wrap.appendChild(badge);
    });

    return wrap;
  }

  /* ---------- Order Summary Sidebar ---------- */
  function renderSidebar() {
    var sidebar = ce('div', 'mw-bb-sidebar');
    var summary = ce('div', 'mw-bb-summary');

    var title = ce('h3', 'mw-bb-summary__title');
    title.textContent = 'Your Bundle \ud83d\uded2';
    summary.appendChild(title);

    // Warmer section
    var warmerSection = ce('div', 'mw-bb-summary__section');
    var warmerLabel = ce('div', 'mw-bb-summary__section-label');
    warmerLabel.textContent = 'Warmer';
    warmerSection.appendChild(warmerLabel);

    if (state.warmer) {
      warmerSection.appendChild(renderSummaryItem(state.warmer, formatPrice(state.warmer.price)));
    } else {
      var empty = ce('div', 'mw-bb-summary__empty');
      empty.textContent = 'Pick your warmer \u2728';
      warmerSection.appendChild(empty);
    }
    summary.appendChild(warmerSection);

    // Melts section
    var meltsSection = ce('div', 'mw-bb-summary__section');
    var meltsLabel = ce('div', 'mw-bb-summary__section-label');
    meltsLabel.textContent = 'Wax Melts (' + getTotalQty(state.melts) + '/' + CONFIG.paidMeltsCount + ')';
    meltsSection.appendChild(meltsLabel);

    if (state.melts.length > 0) {
      state.melts.forEach(function (m) {
        meltsSection.appendChild(renderSummaryItem(m, formatPrice(m.price * m.qty), m.qty > 1 ? 'x' + m.qty : null));
      });
    } else {
      var empty2 = ce('div', 'mw-bb-summary__empty');
      empty2.textContent = 'Grab ' + CONFIG.paidMeltsCount + ' fave scents \ud83d\udc9c';
      meltsSection.appendChild(empty2);
    }
    summary.appendChild(meltsSection);

    // Free melts section
    var freeSection = ce('div', 'mw-bb-summary__section');
    var freeLabel = ce('div', 'mw-bb-summary__section-label');
    freeLabel.textContent = 'Free Melts (' + getTotalQty(state.freeMelts) + '/' + CONFIG.freeMeltsCount + ')';
    freeSection.appendChild(freeLabel);

    if (state.freeMelts.length > 0) {
      state.freeMelts.forEach(function (m) {
        var item = ce('div', 'mw-bb-summary__item');
        var imgW = ce('div', 'mw-bb-summary__item-img');
        if (m.image) {
          var img = ce('img');
          img.src = resizeImage(m.image, 80);
          img.alt = m.title;
          imgW.appendChild(img);
        }
        item.appendChild(imgW);
        var nameEl = ce('span', 'mw-bb-summary__item-name');
        nameEl.textContent = m.title;
        item.appendChild(nameEl);
        var freeTag = ce('span', 'mw-bb-summary__item-free');
        freeTag.textContent = 'FREE';
        item.appendChild(freeTag);
        freeSection.appendChild(item);
      });
    } else {
      var empty3 = ce('div', 'mw-bb-summary__empty');
      empty3.textContent = 'Grab ' + CONFIG.freeMeltsCount + ' freebies \ud83c\udf81';
      freeSection.appendChild(empty3);
    }
    summary.appendChild(freeSection);

    // Divider
    summary.appendChild(ce('div', 'mw-bb-summary__divider'));

    // Subtotal
    var subtotalRow = ce('div', 'mw-bb-summary__row');
    var subtotalLabel = ce('span', 'mw-bb-summary__row-label');
    subtotalLabel.textContent = 'Subtotal';
    var subtotalValue = ce('span', 'mw-bb-summary__row-value');
    subtotalValue.textContent = formatPrice(getSubtotal());
    subtotalRow.appendChild(subtotalLabel);
    subtotalRow.appendChild(subtotalValue);
    summary.appendChild(subtotalRow);

    // Savings
    var savings = getSavings();
    if (savings > 0) {
      var savingsEl = ce('div', 'mw-bb-summary__savings');
      savingsEl.innerHTML = ICONS.tag + ' You\u2019re saving ' + formatPrice(savings) + ' \ud83c\udf89';
      summary.appendChild(savingsEl);
    }

    sidebar.appendChild(summary);
    return sidebar;
  }

  function renderSummaryItem(product, priceText, qtyText) {
    var item = ce('div', 'mw-bb-summary__item');

    var imgW = ce('div', 'mw-bb-summary__item-img');
    if (product.image) {
      var img = ce('img');
      img.src = resizeImage(product.image, 80);
      img.alt = product.title;
      imgW.appendChild(img);
    }
    item.appendChild(imgW);

    var nameEl = ce('span', 'mw-bb-summary__item-name');
    nameEl.textContent = product.title + (qtyText ? ' ' + qtyText : '');
    item.appendChild(nameEl);

    var priceEl = ce('span', 'mw-bb-summary__item-price');
    priceEl.textContent = priceText;
    item.appendChild(priceEl);

    return item;
  }

  /* ---------- Mobile Sticky Bar ---------- */
  function renderMobileBar(current, max, btnLabel, btnDisabled, btnAction) {
    var bar = ce('div', 'mw-bb-mobilebar');

    // Fade gradient
    bar.appendChild(ce('div', 'mw-bb-mobilebar__fade'));

    var inner = ce('div', 'mw-bb-mobilebar__inner');

    var info = ce('div', 'mw-bb-mobilebar__info');

    // Progress dots
    var dots = ce('div', 'mw-bb-mobilebar__dots');
    for (var i = 1; i <= 3; i++) {
      var dot = ce('span', 'mw-bb-mobilebar__dot');
      if (i === state.currentStep) dot.classList.add('mw-bb-mobilebar__dot--active');
      if (i < state.currentStep) dot.classList.add('mw-bb-mobilebar__dot--complete');
      dots.appendChild(dot);
    }
    info.appendChild(dots);

    var count = ce('span', 'mw-bb-mobilebar__count');
    count.textContent = current + ' of ' + max + ' selected';
    info.appendChild(count);

    var price = ce('div', 'mw-bb-mobilebar__price');
    price.textContent = formatPrice(getSubtotal());
    info.appendChild(price);

    inner.appendChild(info);

    var btn = ce('button', 'mw-bb-btn mw-bb-btn--primary');
    btn.type = 'button';
    btn.textContent = btnLabel;
    btn.disabled = btnDisabled;
    btn.onclick = btnAction;
    if (btnLabel.indexOf('Checkout') !== -1) {
      btn.classList.remove('mw-bb-btn--primary');
      btn.classList.add('mw-bb-btn--checkout');
      var btnTextEl = ce('span', 'mw-bb-btn__text');
      btnTextEl.textContent = btnLabel;
      var spinnerEl = ce('span', 'mw-bb-btn__spinner');
      btn.textContent = '';
      btn.appendChild(btnTextEl);
      btn.appendChild(spinnerEl);
    }

    inner.appendChild(btn);
    bar.appendChild(inner);

    return bar;
  }

  /* ---------- Skeleton Loader ---------- */
  function renderSkeleton() {
    var grid = ce('div', 'mw-bb-skeleton-grid');
    for (var i = 0; i < 6; i++) {
      var skel = ce('div', 'mw-bb-skeleton');
      skel.appendChild(ce('div', 'mw-bb-skeleton__img'));
      skel.appendChild(ce('div', 'mw-bb-skeleton__line'));
      var shortLine = ce('div', 'mw-bb-skeleton__line mw-bb-skeleton__line--short');
      skel.appendChild(shortLine);
      grid.appendChild(skel);
    }
    return grid;
  }

  /* ---------- Helpers ---------- */
  function ce(tag, className) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    return el;
  }

  function resizeImage(src, size) {
    if (!src) return '';
    if (src.includes('/files/')) {
      var sep = src.includes('?') ? '&' : '?';
      return src + sep + 'width=' + size;
    }
    return src.replace(/(\.[a-z]+)\?/, '_' + size + 'x$1?');
  }

  /* ---------- Boot ---------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
